import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Manager, Popper, Reference } from 'react-popper';

import i18n from '../../i18n';
import { currencies, getDisplayName } from '../currency';

class CurrencySelector extends React.PureComponent {
    static propTypes = {
        currency: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        placement: PropTypes.string
    };

    static defautProps = {
        placement: 'top'
    };

    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
        this.handleToggle = this.handleToggle.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.blur = this.blur.bind(this);
    }

    componentDidUpdate() {
        // simulate blur event to avoid insonsistance browser focus handles
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
        if (this.state.show) {
            document.body.addEventListener('click', this.blur, true);
        } else {
            document.body.removeEventListener('click', this.blur, true);
        }
    }

    componentWillUnmount() {
        document.body.removeEventListener('click', this.blur, true);
    }

    blur() {
        setTimeout(() => {
            this.setState({ show: false });
        }, 200);
    }

    handleToggle() {
        // add delay on state change to be able to catch click event
        this.setState((state) => ({
            show: !state.show
        }));
    }

    handleClick(e) {
        const code = e.currentTarget.getAttribute('data-code');
        this.props.onChange(code);
        this.setState({ show: false });
    }

    render() {
        const { currency } = this.props;
        return (
            <Manager>
                <Reference>
                    {({ ref }) => (
                        <button
                            className="form-control menulist"
                            type="button"
                            ref={ref}
                            onClick={this.handleToggle}
                        >
                            <span>
                                {getDisplayName(i18n.language, currency, 'name')} - {currencies[currency]}
                            </span>
                        </button>
                    )}
                </Reference>
                {this.state.show && (
                    <Popper
                        placement={this.props.placement}
                        modifiers={{
                            preventOverflow: {
                                enabled: true,
                                boundariesElement: 'scrollParent'
                            }
                        }}
                    >
                        {({ ref, style, placement, arrowProps }) => (
                            <div
                                className="menulist-options menulist-currencies"
                                ref={ref}
                                style={style}
                                data-placement={placement}
                            >
                                <table className="table table-currencies">
                                    <tbody>
                                        {Object.entries(currencies)
                                            .filter(([code]) => code !== 'HRK')
                                            .map(([code, symbol]) => (
                                                <tr
                                                    key={code}
                                                    data-code={code}
                                                    onClick={this.handleClick}
                                                    className={classNames({
                                                        selected: code === currency
                                                    })}
                                                >
                                                    <td className="symbol">{symbol}</td>
                                                    <td className="code">{code}</td>
                                                    <td className="name">
                                                        {getDisplayName(i18n.language, code, 'name')}
                                                    </td>
                                                    <td className="selected">
                                                        {code === currency ? (
                                                            <i className="icon icon-ok" />
                                                        ) : null}
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                <div
                                    ref={arrowProps.ref}
                                    style={arrowProps.style}
                                    data-placement={placement}
                                />
                            </div>
                        )}
                    </Popper>
                )}
            </Manager>
        );
    }
}

export default CurrencySelector;
